import { render } from "./DashboardKpiCard.vue?vue&type=template&id=0e40f25f&scoped=true"
import script from "./DashboardKpiCard.vue?vue&type=script&lang=js"
export * from "./DashboardKpiCard.vue?vue&type=script&lang=js"

import "./DashboardKpiCard.vue?vue&type=style&index=0&id=0e40f25f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e40f25f"]])

export default __exports__